import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'GameCommand',
  emits: ["move"],
  setup(__props, { emit: __emit }) {

const commandsInput = ref("");

const emit = __emit;

const moveForward = () => {
  emit("move", "forward");
};

const turnLeft = () => {
  emit("move", "turnLeft");
};

const turnRight = () => {
  emit("move", "turnRight");
};

const executeCommands = () => {
  for (let command of commandsInput.value.toUpperCase()) {
    switch (command) {
      case "F":
        moveForward();
        break;
      case "L":
        turnLeft();
        break;
      case "R":
        turnRight();
        break;
    }
  }
  commandsInput.value = "";
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _cache[1] || (_cache[1] = _createElementVNode("label", null, "Commands (F, L, R):", -1)),
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((commandsInput).value = $event)),
      type: "text",
      placeholder: "Enter commands (F, L, R)"
    }, null, 512), [
      [_vModelText, commandsInput.value]
    ]),
    _createElementVNode("button", { onClick: executeCommands }, "Execute")
  ]))
}
}

})